export const CAREER_PAGES_TURNED_OFF = 'career_pages_turned_off';
